/* eslint-disable no-useless-assignment -- тут не statement-ы, но переменная используется */
import { type Alias } from '#shared/api/schema';
import {
    CONSTRUCTOR_404_PAGE_ALIAS,
    CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS,
    CONSTRUCTOR_ACCOUNT_NEWSLETTERS_ALIAS,
    CONSTRUCTOR_ACCOUNT_ORDER_DETAILS_ALIAS,
    CONSTRUCTOR_ACCOUNT_ORDERS_ALIAS,
    CONSTRUCTOR_ACCOUNT_PROFILE_ALIAS,
    CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS,
    CONSTRUCTOR_BLOG_ALIAS,
    CONSTRUCTOR_BLOG_ENTRY_ALIAS,
    CONSTRUCTOR_CART_ALIAS,
    CONSTRUCTOR_CART_PREVIEW_ALIAS,
    CONSTRUCTOR_CATALOG_ALIAS,
    CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS,
    CONSTRUCTOR_DELIVERY_ALIAS,
    CONSTRUCTOR_DETAILS_ALIAS,
    CONSTRUCTOR_FAVOURITE_PRODUCTS_ALIAS,
    CONSTRUCTOR_MAIN_PAGE_ALIAS,
    CONSTRUCTOR_OFFER_ALIAS,
    CONSTRUCTOR_PAYMENT_ALIAS,
    CONSTRUCTOR_PRIVACY_ALIAS,
    CONSTRUCTOR_PRODUCT_CARD_ALIAS,
    CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS,
    CONSTRUCTOR_RETURN_ALIAS,
    CONSTRUCTOR_SEARCH_ALIAS,
    CONSTRUCTOR_SUBSCRIPTION_ALIAS,
    CONSTRUCTOR_UNSUBSCRIBE_ALIAS,
} from '../constants';

let i = 1;
const pagesMap = new Map<Alias, number>([
    [CONSTRUCTOR_MAIN_PAGE_ALIAS, i++],
    [CONSTRUCTOR_PRODUCT_CARD_ALIAS, i++],
    [CONSTRUCTOR_CATALOG_ALIAS, i++],
    [CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS, i++],
    [CONSTRUCTOR_SEARCH_ALIAS, i++],
    [CONSTRUCTOR_CART_ALIAS, i++],
    [CONSTRUCTOR_CART_PREVIEW_ALIAS, i++],
    [CONSTRUCTOR_FAVOURITE_PRODUCTS_ALIAS, i++],
    [CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS, i++],
    [CONSTRUCTOR_BLOG_ALIAS, i++],
    [CONSTRUCTOR_BLOG_ENTRY_ALIAS, i++],
    [CONSTRUCTOR_SUBSCRIPTION_ALIAS, i++],
    [CONSTRUCTOR_UNSUBSCRIBE_ALIAS, i++],
    [CONSTRUCTOR_404_PAGE_ALIAS, i++],
    [CONSTRUCTOR_ACCOUNT_PROFILE_ALIAS, i++],
    [CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS, i++],
    [CONSTRUCTOR_ACCOUNT_NEWSLETTERS_ALIAS, i++],
    [CONSTRUCTOR_ACCOUNT_ORDERS_ALIAS, i++],
    [CONSTRUCTOR_ACCOUNT_ORDER_DETAILS_ALIAS, i++],
    [CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS, i++],
    [CONSTRUCTOR_PRIVACY_ALIAS, i++],
    [CONSTRUCTOR_PAYMENT_ALIAS, i++],
    [CONSTRUCTOR_DELIVERY_ALIAS, i++],
    [CONSTRUCTOR_RETURN_ALIAS, i++],
    [CONSTRUCTOR_DETAILS_ALIAS, i++],
    [CONSTRUCTOR_OFFER_ALIAS, i++],
]);

export const getConstructorPageOrder = (a: Alias): number => pagesMap.get(a) || 9999;
